import { Injectable } from '@angular/core';
import {NeoRestService} from '../neo-rest/neo-rest.service';

@Injectable()
export class NeoExtraService {

  constructor(
      private _rest: NeoRestService
  ) { }

    /**
     * Obtiene los detalles de un extra
     *
     * @param extraId
     * @returns {Observable<any>}
     */
    getExtra(extraId) {
        return this._rest.get(`/extra/detail/extraId=${extraId}`);
    }
}



// WEBPACK FOOTER //
// ./src/app/core/services/neo-extra/neo-extra.service.ts